import { useTranslation } from 'react-i18next';
import ConfirmDestructiveModal from '../common/ConfirmDestructiveModal';
import { softBreakIdentifier } from '../../utils/softBreakIdentifier';

interface SampleDeleteModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => Promise<void>;
  sampleName?: string;
  isLoading?: boolean;
}

/** サンプル削除確認（共通 ConfirmDestructiveModal の薄いラッパ） */
export default function SampleDeleteModal({
  show,
  onHide,
  onConfirm,
  sampleName,
  isLoading = false,
}: SampleDeleteModalProps) {
  const { t } = useTranslation();

  return (
    <ConfirmDestructiveModal
      show={show}
      onHide={onHide}
      onConfirm={onConfirm}
      isLoading={isLoading}
      title={t('sample.delete_confirm_title')}
      message={t('sample.delete_confirm_message')}
      closeTitle={t('sample.delete_modal_close_title', {
        defaultValue: 'サンプル削除の確認を閉じる',
      })}
      cancelTitle={t('sample.delete_cancel_title', {
        defaultValue: '削除せずに閉じる',
      })}
      confirmTitle={t('sample.delete_confirm_ok_title', {
        defaultValue: 'このサンプルを削除する',
      })}
    >
      {sampleName ? (
        <p className="fw-bold">{softBreakIdentifier(sampleName, t)}</p>
      ) : null}
      <p className="text-danger small mb-0">{t('sample.delete_warning')}</p>
    </ConfirmDestructiveModal>
  );
}
